module.exports = __webpack_public_path__ + "static/img/rmp_acronym.d747edd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rmp_acronym.png
// module id = hgkV
// module chunks = 3